import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarDays, faCalendarPlus, faListCheck } from '@fortawesome/free-solid-svg-icons';
import { Product } from '../data/interfaces/Product';
import { Variation } from '../data/interfaces/Variation';
import { getGameColor, getPlatformColor } from '../data/objects/gameColor';
import DownloadOptionsButton from './DownloadOptionsButton';
import { Addon } from '../data/interfaces/Addon';
import RequiredModCard from './RequiredModCard';

interface AddonInfoSectionProps {
    product: Product;
    variation: Variation;
    addon: Addon;
}

const AddonPageHeaderInfo: React.FC<AddonInfoSectionProps> = ({ product, variation, addon }) => {

    const gameColor = getGameColor(product.game);

    return (
        <div className="card-body">

            <div className="d-flex align-items-center">
                <div
                    className="game-indicator"
                    style={{
                        backgroundColor: gameColor
                    }}
                ></div>
                <p className="card-text m-0">{product.game}</p>
            </div>
            <div>
                <div className="d-flex align-items-center">
                    <div
                        className="addon-indicator"
                        style={{
                            backgroundColor: gameColor
                        }}
                    ></div>
                    <p className="card-text m-0">Add-on</p>
                </div>
            </div>
            <h1 className="card-text display-5">{addon.title.toUpperCase()}</h1>

            <RequiredModCard
                product={product}
                variation={variation}
            />

            <div className="d-flex align-items-center my-3">
                {product.platforms.map((platform, index) => (
                    <span
                        key={index}
                        className="platform-pill"
                        style={{
                            backgroundColor: getPlatformColor(platform),
                        }}
                    >
                        {platform}
                    </span>
                ))}
            </div>

            <div className="version-info">
                <FontAwesomeIcon icon={faListCheck} />
                <span>Version {addon.version}</span>
            </div>

            <div className="dates-info">
                <FontAwesomeIcon icon={faCalendarDays} />
                <span>Posted: {addon.datePosted}</span>
            </div>

            {addon.dateUpdated && (
                <div className="dates-info">
                    <FontAwesomeIcon icon={faCalendarPlus} />
                    <span>Updated: {addon.dateUpdated}</span>
                </div>
            )}

            <DownloadOptionsButton
                variationPath={`/assets/releases/${addon.releaseId}/variations/v${addon.variationId}/addons/a${addon.addonId}/downloads`}
                addon={addon}
            />
        </div>
    );
};

export default AddonPageHeaderInfo;
